module.exports = __webpack_public_path__ + "static/media/stockhausen_held_8.0e1f6da9.png";